import { BodyResearchRegister } from 'practice/view-models/research-register';
import { HeadCell } from 'shell/components/shared/table/types';

export const headCells: HeadCell<BodyResearchRegister, keyof BodyResearchRegister>[] = [
  {
    id: 'type',
    label: 'Tipo registro',
  },
  {
    id: 'description',
    label: 'Descrizione registro',
  },
  {
    id: 'action',
    label: '',
  },
];
